<script>
    import { goTo } from "@utils/router";
    import {
        GoogleOauth,
        AppleOauth,
        EmailAndPwd,
        Spinner,
    } from "@/components";
    import { translate } from "@/utils/format";

    import { onMount } from "svelte";
    import appStore from "@utils/store";

    import { getMobileOS } from "@/utils/common";
    import { CalooAdminConfig } from "@/services/admin";
    let platform = $state("web"); // Default to web
    let loading = $state(false);

    onMount(() => {
        console.log("Platform detected:", platform);
        checkUser();
    });

    function checkUser() {
        const user = appStore.get("user");
        if (user && user.firebaseUser) {
            goTo("/dashboard");
        } else {
            goTo("/login");
        }
    }
</script>

<div class="login">
    {#if loading}
        <Spinner text="" />
    {/if}
    <div class="login__logo">
        <img src="/assets/img/logo.svg" alt="Logo" />
    </div>
    <p class="signin__txt">
        {translate("WELCOME_BACK", "¡Bienvenido de nuevo!")}<br />
        {translate(
            "LOGIN_TO_CONTINUE",
            "Por favor inicia sesión para continuar.",
        )}
    </p>
    <GoogleOauth onLoading={(val) => (loading = val)} />

    <div class="login__or">{translate("OR", "o")}</div>
    <EmailAndPwd onLoading={(val) => (loading = val)} />
    <p class="login__account">
        {translate("DONT_HAVE_ACCOUNT", "¿No tienes una cuenta?")}
        <a href="/signin" on:click|preventDefault={() => goTo("/signin")}>
            {translate("SIGN_UP", "Regístrate")}
        </a>
    </p>
</div>
